import * as React from 'react'
import { Link } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import DropdownMenuLink from './DropdownMenuLink'
import DropdownMenuContainer from './DropdownMenuContainer'
import PropTypes from 'prop-types'

const AccessoriesDropDownMenu = ({
  dropDown,
  onMenuLinkClick,
  setDropDown,
}) => {
  return (
    <DropdownMenuContainer selectedDropDown={dropDown} dropDownIndex={4} setDropDown={setDropDown}>
      {/* This is the mobile section of the button */}
      <div className="lg:col-span-4 w-full lg:text-center">
        <Link
          to="/accessories/"
          onClick={onMenuLinkClick}
          className="w-[calc(100vw-3em)] md:w-[calc(100vw-11.25rem)] sticky lg:block lg:w-full lg:text-2xl lg:text-gray-600 lg:static font-bold text-red-600 top-0 bg-white justify-between lg:justify-center items-center mb-2 left-0 h-14 flex flex-row border-b lg:border-transparent "
        >
          <div>SHOP ALL ACCESSORIES </div>
          <p className="lg:hidden text-sm py-4 px-5 text-gray-600 font-normal underline underline-offset-2 decoration-slate-300 ">
            See All
            <span className="sr-only">Accessories</span>
          </p>
        </Link>

        <div className="flex flex-col lg:flex-row w-full justify-center lg:gap-5 gap-0 indent-12 lg:indent-0">
          <DropdownMenuLink
            to="/jewelry/estate-jewelry-and-vintage-jewelry/cufflinks/"
            onClick={onMenuLinkClick}
          >
            <div className="aspect-square w-full max-w-[150px] mx-auto bg-gray-50 my-3 hidden lg:block">
              <StaticImage
                src={'../../../images/accessories-cufflinks.jpeg'}
                alt={'Cufflinks'}
                className={
                  'w-full group-hover:scale-110 object-contain mix-blend-multiply scale-105 duration-200'
                }
              />
            </div>
            Cufflinks
          </DropdownMenuLink>
          <DropdownMenuLink to="/accessories/pens/" onClick={onMenuLinkClick}>
            <div className="aspect-square w-full max-w-[150px] mx-auto bg-gray-50 my-3 hidden lg:block">
              <StaticImage
                src={'../../../images/accessories-pen.jpeg'}
                alt={'Fancy and Luxury Pens'}
                className={
                  'w-full group-hover:scale-110 object-contain mix-blend-multiply scale-105 duration-200 '
                }
              />
            </div>
            Pens
          </DropdownMenuLink>
          <DropdownMenuLink to="/accessories/glasses/" onClick={onMenuLinkClick}>
            <div className="aspect-square w-full max-w-[150px] mx-auto bg-gray-50 my-3 hidden lg:block">
              <StaticImage
                src={'../../../images/cartier-glasses.jpeg'}
                alt={'Cartier Glasses'}
                className={
                  'w-full group-hover:scale-110 object-contain mix-blend-multiply scale-105 duration-200'
                }
              />
            </div>
            Glasses
          </DropdownMenuLink>
          <DropdownMenuLink to="/watch-bands/" onClick={onMenuLinkClick}>
            <div className="aspect-square w-full max-w-[150px] mx-auto bg-gray-50 my-3 hidden lg:block">
              <StaticImage
                src={'../../../images/accessories-strap.jpeg'}
                alt={'Watch Bands'}
                className={
                  'w-full group-hover:scale-110 object-contain mix-blend-multiply scale-105 duration-200'
                }
              />
            </div>
            Watch Bands/Straps
          </DropdownMenuLink>

          <DropdownMenuLink to="/accessories/dials/" onClick={onMenuLinkClick}>
            <div className="aspect-square w-full max-w-[150px] mx-auto bg-gray-50 my-3 hidden lg:block">
              <StaticImage
                src={'../../../images/accessories-dial.jpeg'}
                alt={'Watch Dials'}
                className={
                  'w-full group-hover:scale-110 object-contain mix-blend-multiply scale-105 duration-200'
                }
              />
            </div>
            Dials
          </DropdownMenuLink>
          <DropdownMenuLink to="/accessories/collectible-money-coins/" onClick={onMenuLinkClick}>
            <div className="aspect-square w-full max-w-[150px] mx-auto bg-gray-50 my-3 hidden lg:block">
              <StaticImage
                src={'../../../images/coins.png'}
                alt={'Coins & Collectibles'}
                className={
                  'w-full group-hover:scale-105 object-contain mix-blend-multiply scale-95 duration-200'
                }
              />
            </div>
            Coins & Collectibles
          </DropdownMenuLink>

          <DropdownMenuLink to="/accessories/watchwinders/" onClick={onMenuLinkClick}>
            <div className="aspect-square w-full max-w-[150px] mx-auto bg-gray-50 my-3 hidden lg:block">
              <StaticImage
                src={'../../../images/accessories-winder.jpeg'}
                alt={'Cartier Glasses'}
                className={
                  'w-full group-hover:scale-110 object-contain mix-blend-multiply scale-105 duration-200'
                }
              />
            </div>
            Watchwinders
          </DropdownMenuLink>
        </div>
      </div>
    </DropdownMenuContainer>
  )
}
AccessoriesDropDownMenu.propTypes = {
  dropDown: PropTypes.number.isRequired,
  onMenuLinkClick: PropTypes.func.isRequired,
  setDropDown: PropTypes.func.isRequired,
}

export default AccessoriesDropDownMenu
